import { ApiSingleton } from '../resource';
class Applications extends ApiSingleton {
    isApplication(resource) {
        return resource.type && (resource.type === Applications.TYPE);
    }
    relationship(id) {
        return ((id === null) || (typeof id === 'string')) ? { id, type: Applications.TYPE } : { id: id.id, type: Applications.TYPE };
    }
    type() {
        return Applications.TYPE;
    }
}
Applications.TYPE = 'application';
export default Applications;
